import RoomsView from './RoomsViewContainer';
export default RoomsView;
